<kendo-dialog-titlebar>
    Override Alert
</kendo-dialog-titlebar>
<div class="dialog-content-container">
    <p style="margin: 10px; text-align: center;">{{constraintAlert.error}}</p>
    <p style="margin: 10px; text-align: left;">Standard Class: {{ constraintAlert.standard.fare ? (constraintAlert.standard.fare | kendoNumber:'c') : '-'}} {{constraintAlert.standard.bucketCode}}</p>
    <p style="margin: 10px; text-align: left;">First Class: {{ constraintAlert.first.fare ? (constraintAlert.first.fare | kendoNumber:'c') : '-'}} {{constraintAlert.first.bucketCode}}</p>
    <p style="margin: 10px; text-align: center;">Would you like to continue?</p>
</div>